import styled from '@emotion/styled';
import React from 'react';
import { Button, Divider, Heading, Icon } from '.';

const CustomButton = styled(Button)`
	padding: 2px 1rem;
`;
const CustomButtonLink = styled(Heading)`
	padding: 0.375rem 1.125rem;
	padding-bottom:0.325rem !important;
	margin-bottom: 0px !important;
	color: var(--deepBlue);
	line-height: 10px;
	margin-left: 1rem;
	border-bottom: 1px solid var(--deepBlue);
	cursor: pointer;
	&:hover {
		color: var(--deepBlue);
	}
`;
function ReactToolTipBox({
	width = '200px',
	number,
	information,
    description,
	handleNext,
	handleClose,
	handleDisable,
	handleSkip,
}) {
	return (
		<div className='py-1 px-3' style={{ width: width }}>
			<div
				onClick={handleClose}
				style={{
					position: 'absolute',
					right: '5px',
					top: '5px',
					cursor: 'pointer',
				}}
			>
				<Icon style={{ fontSize: '20px' }} color='var(--deepBlue)'>
					close
				</Icon>
			</div>

			<div className='d-flex align-items-center'>
				
				<div>
					<Heading
						fontSize='11px'
						// fontWeight='700'
						breakHeading={false}
						className='mb-0 pb-0'
						style={{
							whiteSpace: 'pre-line',
							// lineHeight: '19px',
                            // color:'green',
                            // marginBottom:'1px'
						}}
					>
						{information}
					</Heading>
				</div>
			</div>
            <div className='d-flex align-items-center'>
				
				<div>
					<Heading
						fontSize='12px'
						fontWeight='700'
						breakHeading={false}
						className='mb-0 pb-0'
						style={{
							whiteSpace: 'pre-line',
							lineHeight: '19px',
                            marginTop:'10px'
						}}
					>
						{description}
					</Heading>
				</div>
			</div>
			<div className='d-flex  align-items-center mt-1 '>
				
				<div onClick={handleClose}>
					{/* <CustomButtonLink
						fontSize='10px'
						fontWeight='400'
						size='small'
						simple
					
						className='mb-0 pb-0'
                        style={{
							
                           
                            padding: '0.375rem 1.125rem',
                            marginLeft:'-4px',
                            borderRadius:'25px',
                            
						}}
					>
						Skip for now
					</CustomButtonLink> */}
					<CustomButton
					fontSize='10px'
					fontWeight='600'
					size='small'
					buttonColor='var(--sapGreen)'
					// onClick={handleClose}
				>
					Next
				</CustomButton>
				</div>
				
			</div>
		</div>
	);
}

export default ReactToolTipBox;
